import { Button, Modal, Space } from 'antd'
import React, { ReactNode } from 'react'
import "./common.scss"
import { isEmpty } from 'lodash'
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  closeIcon: boolean;
  loading?: boolean;
  title: string;
  className?: string;
  width?: string;
  desc: any;
  okText: string;
  cancelText: string;
  disableButton?: boolean;
  closeModal: (value: boolean) => void;
  confirm: () => void;
  icon: ReactNode;
  maskClosable?: boolean
}

export default function CommonModal(props: Props) {
  const { t } = useTranslation();
  const { open, title, closeIcon, okText, cancelText, closeModal, icon, confirm, desc, width, className, loading = false, disableButton = false, maskClosable = true } = props

  const onOk = () => {
    confirm()
  }

  return (
    <Modal
      className={!isEmpty(className) ? className : 'modal-common'}
      title={<>{icon} <span>{typeof title === "string" ? t(title, title) : title}</span></>}
      style={{ width: `${width}` }}
      closeIcon={closeIcon}
      centered
      onCancel={() => closeModal(false)}
      open={open}
      maskClosable={maskClosable}
      footer={(_, { }) => (
        <div className="modal-btn-center">
          <Space size="small">
            <Button onClick={() => closeModal(false)}>{typeof cancelText === "string" ? t(cancelText, cancelText) : cancelText}</Button>
            <Button disabled={disableButton} loading={loading} onClick={onOk} className='btn btn-primary'>{typeof okText === "string" ? t(okText, okText) : okText}</Button>
          </Space>
        </div>
      )}
    >
      <div className='description'>
        {typeof desc === "string" ? t(desc, desc) : desc}
      </div>
    </Modal>
  )
}
